import { put, takeEvery } from "redux-saga/effects";
import { fetchGraphMethod, fetchMethod } from "../../../../services/httpService";
import messagePopup from "../../../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
  RECRUITING_PHILOSOPHY_LIST_START: "RECRUITING_PHILOSOPHY_LIST_START",
  SAVE_RECRUITING_PHILOSOPHY_START: "SAVE_RECRUITING_PHILOSOPHY_START",
  RECRUITING_PHILOSOPHY_SUCCESS: "RECRUITING_PHILOSOPHY_SUCCESS",
  RECRUITING_PHILOSOPHY_FAILED: "RECRUITING_PHILOSOPHY_FAILED",
};

// ============================================ Actions ========================================================
export const getRecruitingPhilosophyListStart = (data) => ({
  type: actionType.RECRUITING_PHILOSOPHY_LIST_START,
  payload: data,
});

export const saveRecruitingPhilosophy = (data) => ({
    type: actionType.SAVE_RECRUITING_PHILOSOPHY_START,
    payload: data,
  });

export const getRecruitingPhilosophySuccess = (data) => ({
  type: actionType.RECRUITING_PHILOSOPHY_SUCCESS,
  payload: data,
});

export const getRecruitingPhilosophyFailed = (data) => ({
  type: actionType.RECRUITING_PHILOSOPHY_FAILED,
  payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
  loading: false,
  data: null,
  error: null,
};

export default function getRecruitingPhilosophyReducer(
  state = INIT_STATE,
  action
) {
  switch (action.type) {
    case actionType.RECRUITING_PHILOSOPHY_LIST_START:
      return {
        ...state,
        loading: true,
      };
      case actionType.SAVE_RECRUITING_PHILOSOPHY_START:
        return {
          ...state,
          loading: true,
        };
    case actionType.RECRUITING_PHILOSOPHY_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case actionType.RECRUITING_PHILOSOPHY_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return { ...state };
  }
}

// ===================================================== side effect =============================================

export function* recruitingPhilosophyListSaga(action) {
    try {
        const response = yield fetchGraphMethod(action.payload.query, action.payload.variables, true);
        if (response && response.status === 200) {
            const allRecruitingPhilosophyList =  response?.data?.data
            yield put(getRecruitingPhilosophySuccess(allRecruitingPhilosophyList));
        } else {
            messagePopup("", "Recruiting Philosophy List failed", "error");
            yield put(getRecruitingPhilosophyFailed("Recruiting Philosophy List failed"));
        }
    } catch (error) {
        messagePopup("", "Recruiting Philosophy List failed", "error");
        yield put(getRecruitingPhilosophyFailed("Recruiting Philosophy List failed"));
    }
}

function* saveRecruitingPhilosophySaga(action) {
    try {
        const response = yield fetchGraphMethod(action.payload.query, action.payload.variables, true)
        if(response && response.status == 200) {
            if(action.payload.getRecruitsListData) action.payload.getRecruitsListData();
            const recruitingPhilosophy = response;
            yield put(getRecruitingPhilosophySuccess(recruitingPhilosophy));
            
        } else {
          messagePopup('', 'Save Recruiting Philosophy  failed', 'error');
          yield put(getRecruitingPhilosophyFailed('Failed, Error occured'))
        }
    } catch (error) {
        messagePopup('', 'Save Recruiting Philosophy  failed', 'error');
        yield put(getRecruitingPhilosophyFailed('Failed, Error occured'))
    }
}

export function* watchRecruitingPhilosophyListSaga() {
  yield takeEvery(actionType.RECRUITING_PHILOSOPHY_LIST_START, recruitingPhilosophyListSaga);
  yield takeEvery(actionType.SAVE_RECRUITING_PHILOSOPHY_START, saveRecruitingPhilosophySaga);

}
